import React from 'react';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: 'Home', href: '#home' },
    { name: 'Education', href: '#education' },
    { name: 'Experience', href: '#experience' },
    { name: 'Publications', href: '#publications' },
    { name: 'Skills', href: '#skills' },
    { name: 'Contact', href: '#contact' }
  ];

  const contactInfo = [
    {
      icon: '📧',
      label: 'Email',
      value: 'pksingh.shobhan@gmail.com',
      href: 'mailto:pksingh.shobhan@gmail.com'
    },
    {
      icon: '📱',
      label: 'Phone',
      value: '+91-8853898608',
      href: 'tel:+918853898608'
    },
    {
      icon: '🏢',
      label: 'Current',
      value: 'Pimpri Chinchwad University, Pune'
    },
    {
      icon: '📍',
      label: 'Permanent',
      value: 'Kanpur, Uttar Pradesh'
    }
  ];

  const socialLinks = [
    {
      name: 'LinkedIn',
      icon: '💼',
      href: '#',
      color: '#0077b5'
    },
    {
      name: 'ResearchGate',
      icon: '🔬',
      href: '#',
      color: '#00ccbb'
    },
    {
      name: 'Google Scholar',
      icon: '📚',
      href: '#',
      color: '#4285f4'
    },
    {
      name: 'ORCID',
      icon: '🆔',
      href: '#',
      color: '#a6ce39'
    }
  ];

  const academicProfiles = [
    {
      platform: 'Scopus Author',
      description: 'Research Publications',
      icon: '🔍'
    },
    {
      platform: 'ABDC Journals',
      description: 'Quality Research',
      icon: '📊'
    },
    {
      platform: 'Indian Patent',
      description: 'Innovation & Research',
      icon: '💡'
    }
  ];

  const scrollToSection = (sectionId) => {
    const element = document.querySelector(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer id="contact" className="footer">
      <div className="footer-wave">
        <svg viewBox="0 0 1200 120" preserveAspectRatio="none">
          <path d="M0,0V46.29c47.79,22.2,103.59,32.17,158,28,70.36-5.37,136.33-33.31,206.8-37.5C438.64,32.43,512.34,53.67,583,72.05c69.27,18,138.3,24.88,209.4,13.08,36.15-6,69.85-17.84,104.45-29.34C989.49,25,1113-14.29,1200,52.47V0Z" opacity=".25" className="shape-fill"></path>
          <path d="M0,0V15.81C13,36.92,27.64,56.86,47.69,72.05,99.41,111.27,165,111,224.58,91.58c31.15-10.15,60.09-26.07,89.67-39.8,40.92-19,84.73-46,130.83-49.67,36.26-2.85,70.9,9.42,98.6,31.56,31.77,25.39,62.32,62,103.63,73,40.44,10.79,81.35-6.69,119.13-24.28s75.16-39,116.92-43.05c59.73-5.85,113.28,22.88,168.9,38.84,30.2,8.66,59,6.17,87.09-7.5,22.43-10.89,48-26.93,60.65-49.24V0Z" opacity=".5" className="shape-fill"></path>
          <path d="M0,0V5.63C149.93,59,314.09,71.32,475.83,42.57c43-7.64,84.23-20.12,127.61-26.46,59-8.63,112.48,12.24,165.56,35.4C827.93,77.22,886,95.24,951.2,90c86.53-7,172.46-45.71,248.8-84.81V0Z" className="shape-fill"></path>
        </svg>
      </div>

      <div className="footer-content">
        <div className="container">
          {/* Main Footer Content */}
          <div className="footer-main">
            {/* Brand Section */}
            <div className="footer-brand">
              <div className="brand-logo">
                <span className="logo-text">PK</span>
              </div>
              <div className="brand-info">
                <h3 className="brand-name">Dr. Pawan Kumar</h3>
                <p className="brand-title">Assistant Professor & Researcher</p>
                <p className="brand-description">
                  Dedicated educator and researcher with 8+ years of experience in management education, 
                  specializing in AI applications, tourism, and organizational management.
                </p>
              </div>
            </div>

            {/* Quick Links */}
            <div className="footer-links">
              <h4 className="links-title">Quick Links</h4>
              <ul className="links-list">
                {quickLinks.map((link, index) => (
                  <li key={index} className="link-item">
                    <button 
                      onClick={() => scrollToSection(link.href)}
                      className="link-button"
                    >
                      {link.name}
                    </button>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact Information */}
            <div className="footer-contact">
              <h4 className="contact-title">Get In Touch</h4>
              <div className="contact-list">
                {contactInfo.map((contact, index) => (
                  <div key={index} className="contact-item">
                    <span className="contact-icon">{contact.icon}</span>
                    <div className="contact-details">
                      <span className="contact-label">{contact.label}</span>
                      {contact.href ? (
                        <a 
                          href={contact.href} 
                          className="contact-value"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {contact.value}
                        </a>
                      ) : (
                        <span className="contact-value">{contact.value}</span>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Academic Profiles */}
            <div className="footer-profiles">
              <h4 className="profiles-title">Academic Profiles</h4>
              <div className="profiles-list">
                {academicProfiles.map((profile, index) => (
                  <div key={index} className="profile-item">
                    <span className="profile-icon">{profile.icon}</span>
                    <div className="profile-info">
                      <span className="profile-platform">{profile.platform}</span>
                      <span className="profile-description">{profile.description}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Social Links */}
          <div className="footer-social">
            <div className="social-content">
              <h5 className="social-title">Connect With Me</h5>
              <div className="social-links">
                {socialLinks.map((social, index) => (
                  <a
                    key={index}
                    href={social.href}
                    className="social-link"
                    style={{ '--social-color': social.color }}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={social.name}
                  >
                    <span className="social-icon">{social.icon}</span>
                    <span className="social-name">{social.name}</span>
                  </a>
                ))}
              </div>
            </div>
          </div>

          {/* Footer Bottom */}
          <div className="footer-bottom">
            <div className="footer-copyright">
              <p>&copy; {currentYear} Dr. Pawan Kumar. All rights reserved.</p>
              <p className="copyright-sub">
                Dedicated to excellence in education and research.
              </p>
            </div>
            
            <div className="footer-actions">
              <button 
                onClick={scrollToTop}
                className="back-to-top"
                aria-label="Back to top"
              >
                <span className="arrow-icon">↑</span>
                <span className="top-text">Back to Top</span>
              </button>
            </div>
          </div>

          {/* Achievement Badges */}
          <div className="achievement-badges">
            <div className="badge">
              <span className="badge-icon">🎓</span>
              <span className="badge-text">8+ Years Experience</span>
            </div>
            <div className="badge">
              <span className="badge-icon">🔬</span>
              <span className="badge-text">15+ Publications</span>
            </div>
            <div className="badge">
              <span className="badge-icon">💡</span>
              <span className="badge-text">Patent Holder</span>
            </div>
            <div className="badge">
              <span className="badge-icon">🏆</span>
              <span className="badge-text">AI Research Expert</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;